<div class="list-group list-group-flush">
	<% if (data.length > 0) for (const site of data) { %>
	<button class="list-group-item list-group-item-action px-2" onclick="Anvil.page.openSite(<%- site.company_db_id %>, <%- site.id %>);">
		<div class="row g-2">
			<div class="col-auto">
				<i class="fa fa-fw fa-map-marker"></i>
			</div>
			<div class="col">
				<strong><%= site.company_name %></strong><br />
				<small>
					<%= site.name %><br />
					<%= site.full_address %>
				</small>
			</div>
		</div>
	</button>
	<% } else { %>
	<span class="pt-3 text-center text-secondary">- nincs találat -</span>
	<% } %>
</div>
